import React, { useId } from 'react';

interface Props {
  className?: string;
}

const DaDrawLogoAndTextColoredAndBranded: React.FC<Props> = ({ className }) => {
  const gradientId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="98"
      height="33"
      viewBox="0 0 98 33"
      fill="none"
      className={className}
    >
      <path
        fill={`url(#${gradientId})`}
        d="M33.84 0c-.06.18-.05.56-.11.71-.02.03-.06.03-.07.06-.1.3-.25.48-.4.77-1.07 1.93-1.91 3.93-2.92 5.88-.8 1.56-1.86 3.15-2.54 4.75-.04.08-.21.44-.03.33.2-.13.72-.95.89-1.19 1.16-1.66 2.16-3.37 3.22-5.1.3-.48.6-1.03.94-1.48.12-.17.38-.57.44-.1.04.38-.2 1.17-.32 1.56-.28.93-.66 1.83-1 2.74-.04 0-.01-.05 0-.07.03-.13.1-.26.15-.39.1-.3.21-.63.3-.95l.1-.42c0-.04-.01-.03-.05-.03a43.7 43.7 0 0 0-3.98 6.64l-.01.07 1.95-3.1.2-.24-.44.93.05.02-1.6 3.91.05.04c.1-.16.22-.3.31-.46.4-.67.78-1.44 1.14-2.13.62-1.21 1.22-2.43 1.74-3.7l.02.05-1.67 4.04c-.06.22-.26.48-.32.68l.01.03.94-1.27.01.03c-1.49 2.84-3.03 5.65-4.46 8.5 0 .15.26.4.34.51h4.3v6.34h-7.89c-.32.2-.55.37-.76.7-.86 1.29-1.45 3.12-2.48 4.25-.02.02-.06.04-.05.09h-4.7l.01-4.6 4.7-8.89c0-.02-.26-.4-.3-.42-.01-.01-.02-.03-.05-.03l-4.33-.03-.02-6.31H23c.2-.18.48-.29.67-.45.21-.18.5-.63.68-.88.69-.92 1.35-1.88 2-2.85l3.13-4.23c0 .11-.03.27.13.18.16-.08.5-.65.62-.83.46-.69.84-1.38 1.37-2.02.05-.06.4-.5.46-.44.01.15-.05.3-.1.45-.08.21-.2.46-.3.67-.72 1.54-1.57 3.02-2.37 4.52l.02.04c.7-.8 1.26-1.72 1.82-2.63h.04c-.81 1.5-1.64 3-2.32 4.57.02.04.05 0 .07-.02.26-.25.58-.72.8-1.02 1.5-2.14 2.35-4.68 3.63-6.95l.5-.83ZM4.78 12.17c.18 3.15 1.27 4.23 4.42 4.42v.06c-3.15.19-4.24 1.27-4.42 4.42h-.06c-.19-3.15-1.27-4.23-4.42-4.42v-.06c3.15-.19 4.23-1.27 4.42-4.42zM10.52.75c.29 5.06 2.03 6.8 7.08 7.09v.1c-5.05.3-6.79 2.03-7.08 7.09h-.11c-.3-5.06-2.03-6.8-7.08-7.09v-.1c5.05-.3 6.79-2.03 7.08-7.09h.1ZM26.95 13.4c-.18.21-.33.49-.46.73-.1.2-.22.4-.25.62.18-.22.33-.5.46-.76.1-.18.22-.38.25-.59m1.12-3.62c-.24.04-.65.97-.6 1.19.01.1.1.05.15.02.27-.14.63-.76.6-1.06-.01-.06-.08-.16-.15-.15m-.1-3.25c-.08.08-.24.23-.3.34-.03.06.08-.02.05.04l-1.88 2.7c.47-.5.88-1.06 1.27-1.62.31-.46.65-.95.87-1.46Z"
      ></path>
      <path
        fill="currentColor"
        d="M41.6 14.15c2.2 0 3.87.58 5 1.74 1.14 1.14 1.71 2.81 1.71 5.02 0 2.34-.61 4.1-1.84 5.28-1.22 1.19-3.12 1.78-5.7 1.78h-4.93v-4.18l3.09-5.75h.75v6.78H41c1.15 0 2-.3 2.54-.89.55-.59.83-1.56.83-2.9 0-1.28-.27-2.21-.79-2.8-.52-.6-1.33-.9-2.42-.9H39.3l1.7-3.18h.58ZM83 23.76h.28l2.14-9.5h3.56l2.14 9.5h.28l1.68-9.5h3.62v1.2l-2.86 12.5h-4.68l-1.92-8.12h-.28l-1.92 8.12h-4.68l-2.86-12.5v-1.2h3.82zM56.31 14.3c3.73 0 5.59 1.45 5.59 4.34 0 .78-.22 1.5-.67 2.17a4.65 4.65 0 0 1-2.1 1.63l3.32 4.3v1.2h-3.9L55 22.81v-1.28a5.7 5.7 0 0 0 2.22-.87c.47-.37.7-.87.7-1.5s-.18-1.11-.54-1.45c-.35-.33-.93-.5-1.73-.5h-1.28v10.71h-3.86V14.3zm21.17 12.44v1.2H73.8l-.75-2.4h-4.93l-.75 2.4h-3.52v-1.2l4.47-12.44h4.7zm-8.5-4.02h3.2l-1.44-4.7h-.3l-1.45 4.7Z"
      ></path>
      <defs>
        <linearGradient
          id={gradientId}
          x1="31.21"
          x2="16.24"
          y1="3.04"
          y2="32.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.02" stopColor="#5539F0"></stop>
          <stop offset="1" stopColor="#C146AB"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

DaDrawLogoAndTextColoredAndBranded.displayName = 'DaDrawLogoAndTextColoredAndBranded';

export default DaDrawLogoAndTextColoredAndBranded;
